import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { IntegrationClientKind } from '@/types/schema';

/**
 * Whether the "Import data" step should offer the eMoney-only Liabilities and
 * Life insurance tabs alongside Entities.
 *
 * The tabs depend on the integration, not on the older
 * `enable_emoney_assets_liabilities` flag.
 */
export function useShowEmoneyImportPanes(): boolean {
  const { householdIntegrationLink } = useHouseholdDetailsContext();
  return householdIntegrationLink === IntegrationClientKind.Emoney;
}
